import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Modal, Button, Form, InputGroup, Badge } from 'react-bootstrap';
import DataTable from 'react-data-table-component';
import { getRequest, putRequest } from '../../helpers/apiHandler';
import { Link } from 'react-router-dom';
import config from '../../config/Constant';
import CustomAlert from '../CustomAlert';
import searchIcon from '../../assets/SidebarIcons/icon-search.svg';
import SpamDetailsModel from './SpamDetailsModel';

const SpamReport = () => {
  const { access_token } = useSelector((state) => state.auth.user);
  const [loadingData, setLoadingData] = useState(false);
  const [search, setSearch] = useState('');
  const [data, setData] = useState([]);
  const [searchData, setSearchData] = useState([]);
  const [columns, setColumns] = useState([]);
  const [spamDetailsShow, setSpamDetailsShow] = useState(false);
  const [userID, setUserID] = useState('');

  const [alertState, setAlertState] = useState({
    show: false,
    variant: 'danger',
    message: '',
  });

  const getAccountStatus = (status) => {
    let style = { color: '#1faf38', background: 'rgba(31,175,56,0.2)' };

    if (status === true) {
      style = { color: '#f15a24', background: 'rgba(241,90,36,0.2)' };
    }

    return <Badge style={style}>{status === true ? 'Suspended' : 'Active'}</Badge>;
  };

  const getSpamData = () => {
    setLoadingData(true);
    const payload = { headers: { Authorization: access_token.token } };
    getRequest(`/admin/spam-report`, payload, (res) => {
      if (res.success) {
        const result = res.data;
        setData(result);
        setSearchData(result);
        generateColumns(result);
      } else {
        setAlertState({
          message: 'There was an issue while fetching global rates',
          show: true,
          variant: 'danger',
        });
      }
      setLoadingData(false);
    });
  };

  const openSpamDetailsModel = (id) => {
    setSpamDetailsShow(true);
    setUserID(id);
  };

  const handleSetStatus = (user_id, status) => {
    const data = {
      user_id: user_id,
      status: status,
    };
    putRequest(`/admin/spam-report-status-update`, data, access_token.token, (res) => {
      if (res.success) {
        getSpamData();
        setAlertState({
          message: 'Updated account status successfully.',
          show: true,
          variant: 'success',
        });
      } else {
        setAlertState({
          message: 'Failed to update account status',
          show: true,
          variant: 'danger',
        });
      }
    });
  };

  const generateColumns = (data) => {
    if (data.length > 0) {
      const generateColumns = [
        { name: 'Name', sortable: true, selector: (row) => row.name },
        { name: 'Email', sortable: true, selector: (row) => row.email },
        { name: 'User ID', sortable: true, selector: (row) => row.id },
        {
          name: 'Spam Activity Detail',
          sortable: true,
          selector: (row) => <Link onClick={() => openSpamDetailsModel(row.id)}>Details</Link>,
        },
        { name: 'Spam Count', sortable: true, selector: (row) => row.spam_count },
        {
          name: 'User Account Status',
          sortable: true,
          selector: (row) => getAccountStatus(row.is_deleted),
        },
        {
          name: 'Actions',
          minWidth: '250px',
          selector: (row) => (
            <div className="d-flex justify-content-center align-items-center gap-1">
              <Button
                variant="danger"
                onClick={() => handleSetStatus(row.id, 'suspend')}
                style={{ minWidth: 100 }}
                disabled={row.is_deleted}
              >
                Suspend
              </Button>
              <Button
                variant="primary"
                onClick={() => handleSetStatus(row.id, 'restore')}
                style={{ minWidth: 100 }}
                disabled={!row.is_deleted}
              >
                Restore
              </Button>
            </div>
          ),
        },
      ];
      setColumns(generateColumns);
    }
  };

  const onSearch = (evt) => {
    const { value } = evt.target;
    const filteredData = data.filter(
      (item) =>
        item.name.toLowerCase().includes(value.toLowerCase()) ||
        item.email.toLowerCase().includes(value.toLowerCase())
    );

    setSearch(value);
    setSearchData(value ? filteredData : data);
  };

  useEffect(() => {
    getSpamData();
  }, []);

  useEffect(() => {
    if (alertState.show) {
      setTimeout(() => {
        setAlertState({
          message: '',
          show: false,
          variant: '',
        });
      }, config.notify_time);
    }
  }, [alertState]);

  return (
    <div className="w-100">
      <div className="page-heading admin-heading">
        <div className="container-left" style={{ marginBottom: '32px' }}>
          <div className="page-title">SPAM Report</div>
        </div>
        <div className="container-right mt-0">
          <InputGroup className="datatable-search search-input">
            <InputGroup.Append>
              <InputGroup.Text>
                <img alt="..." src={searchIcon} />
              </InputGroup.Text>
            </InputGroup.Append>
            <Form.Control
              placeholder="Search..."
              name="search"
              value={search}
              onChange={onSearch}
              className="search-form"
            />
          </InputGroup>
        </div>
      </div>
      <CustomAlert
        message={alertState.message}
        show={alertState.show}
        variant={alertState.variant}
        closeAlert={() => setAlertState({ show: false, variant: 'danger', message: '' })}
      />
      <DataTable
        columns={columns}
        data={searchData}
        progressPending={loadingData}
        paginationComponentOptions={{
          rowsPerPageText: 'Items per page:',
        }}
        pagination
      />
      <SpamDetailsModel
        onShow={spamDetailsShow}
        userID={userID}
        setUserID={setUserID}
        setSpamDetailsShow={setSpamDetailsShow}
      />
    </div>
  );
};

export default SpamReport;
